<template>
  <div id="app">
    <Error v-if="isError" />
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Error from '@/views/Error.vue'
import { message } from '@/utils/message'

export default {
  name: 'App',
  mixins: [message],
  components: {
    Error
  },
  data() {
    return {
      active: false,
      degrade: window.Proxy
    }
  },
  computed: {
    ...mapState('error', ['isError'])
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
$header-height: 60px;
$menu-width: 201px;
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
</style>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100vh;
  --theme: rgb(241, 107, 95);
}

.wujie_iframe {
  width: 100%;
  height: 100%;
}

iframe {
  border: none;
}
</style>
